import { render, staticRenderFns } from "./base-doughnut-chart-v2.vue?vue&type=template&id=7ef236b2&scoped=true"
import script from "./base-doughnut-chart-v2.vue?vue&type=script&lang=js"
export * from "./base-doughnut-chart-v2.vue?vue&type=script&lang=js"
import style0 from "./base-doughnut-chart-v2.vue?vue&type=style&index=0&id=7ef236b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef236b2",
  null
  
)

export default component.exports